import request from './services/axios.js'

export default {
  //设置基础信息
  setBookBasicInfo: (params) => {
    return request({
      data: params,
      url: '/ebook/setBookBasicInfo',
      method: 'post'
    })
  },
  //设置背景
  setBookBg: (params) => {
    return request({
      url: `/ebook/setBookBackground`,
      data: params,
      method: 'post'
    })
  },
  //设置个性化选项
  setPersonalConfig: (params) => {
    return request({
      data: params,
      url: '/ebook/customizeBook',
      method: 'post'
    })
  },
  //设置目录
  setCatalog: (params) => {
    return request({
      params,
      url: '/ebook/setBookCatalog',
      method: 'post'
    })
  },
  //替换PDF
  resetPDF: (params) => {
    return request({
      data: params,
      url: '/cloudR/ebook/changePdfUpload',
      method: 'post'
    })
  },
  //编辑书刊
  editEbook: (params) => {
    return request({
      data: params,
      // data: JSON.stringify(params),
      url: '/ebook/editEbook',
      method: 'post',
      contenType: 'application/json'
    })
  },
  //编辑书刊上传图片接口缩略图、背景、logo
  uploadPicture: (params) => {
    return request({
      data: params,
      url: '/ebook/uploadPic',
      method: 'post'
    })
  },
  //获取图片列表
  getImageList: (params) => {
    return request({
      params,
      url: 'ebook/getImageList',
      method: 'get'
    })
  },
  //删除图片
  delImage: (params) => {
    return request({
      params,
      url: 'ebook/delImage',
      method: 'get'
    })
  },
  //编辑书刊上传音乐
  uploadMusic: (params) => {
    return request({
      data: params,
      url: '/ebook/uploadFile',
      method: 'post'
    })
  },
  //合并上传
  mergePDF: (params) => {
    return request({
      data: params,
      url: '/cloudR/ebook/mergeParse',
      method: 'post'
    })
  },
  //批量上传
  batchPDF: (params) => {
    return request({
      data: params,
      url: '/cloudR/ebook/batchParse',
      method: 'post'
    })
  },
  mergePDFpaper: (params) => {
    return request({
      data: params,
      url: '/cloudR/epaper/mergeParse',
      method: 'post'
    })
  },
  //批量上传
  batchPDFpaper: (params) => {
    return request({
      data: params,
      url: '/cloudR/epaper/batchParse',
      method: 'post'
    })
  },
  //合并上传pdf替换
  mergePDFReplace: (params) => {
    return request({
      data: params,
      url: '/cloudR/ebook/mergeReplace',
      method: 'post'
    })
  },
  mergePDFpaperReplace: (params) => {
    return request({
      data: params,
      url: '/cloudR/epaper/mergeReplace',
      method: 'post'
    })
  },
  //数字报详情 - 编辑小样（form-data）
  editXiaoYangDetail: (params) => {
    const data = new URLSearchParams()
    data.append('id', params.id)
    data.append('title', params.title)
    data.append('content', params.content)
    data.append('fileAttachIds', params.fileAttachIds)
    data.append('deleteFileAttachIds', params.deleteFileAttachIds)
    data.append('addFileAttachIds', params.addFileAttachIds)
    return request.post('/ebook/epaperXY/editEpaperXY', data)
  },
  //数字报列表 - 编辑
  editEpaper: (params) => {
    return request({
      data: params,
      url: '/ebook/epaper/editEpaper',
      method: 'post'
    })
  },
  //富媒体编辑接口
  richMediaEditor: (params) => {
    return request({
      data: params,
      url: '/ebook/epaper/richMediaEditor',
      method: 'post'
    })
  },
  addFileAttach: (params) => {
    return request({
      data: params,
      url: '/ebook/fileAttach/addFileAttach',
      method: 'post'
    })
  }
}
//获取书刊默认设置
export const getDefaultSetting = () => {
  return request({
    url: '/ebook/getDefaultSetting',
    method: 'get'
  })
}

//默认书刊设置授权是否失效
export const checkSettingExpire = () => {
  return request({
    url: '/ebook/checkSettingExpire',
    method: 'get'
  })
}

export const resetDefaultSetting = () => {
  return request({
    url: '/ebook/resetDefaultSetting',
    method: 'get'
  })
}

//编辑默认设置
export const editDefaultSetting = (params) => {
  return request({
    data: params,
    url: '/ebook/editDefaultSetting',
    method: 'post',
    contenType: 'application/json'
  })
}
//批量修改个性设置
export const batchModifySetting = (params) => {
  return request({
    data: params,
    url: '/ebook/batchModifySetting',
    method: 'post',
    contenType: 'application/json'
  })
}
//批量修改背景
export const batchModifyBg = (params) => {
  return request({
    data: params,
    url: '/ebook/batchModifyBg',
    method: 'post',
    contenType: 'application/json'
  })
}
